<p-toast [style]="{marginTop: '41vh'}" position="top-center" key="venimpcli"></p-toast>
<p-confirmDialog [transitionOptions]="'0ms'" key="confirmvenimpcli" title="Confirmar Acción" appendTo="body">
</p-confirmDialog>
<div class="p-grid" style="width: 98%">
    <div class="p-col-12">
        <!-- <app-invmaebarra (signal)="manejarSenales($event)" [botonNuevo]="botonNuevo" [botonGuardar]="botonGuardar"
                [botonBorrar]="botonBorrar" [botonRegresar]="false" [botonBuscarPermanente]="false"
                [barraBotones3]="barraBotones2" [barraBotones3]="barraBotones2" [botonDescargaPermanente]="true">
            </app-invmaebarra> -->
        
        <app-invmaebarra [botonNuevo]="botonNuevo" [botonGuardar]="botonGuardar" [botonBorrar]="botonBorrar"
            [botonRegresar]="botonRegresar" [barraBotonesCRUD]="false" [barraBotonesDesplaz]="true" [barraBotones3]="true"
            [botonDescargaPermanente]="true"
            [barraBotonesAsiCon]="true" [barraBotones5]="true" (signal)="manejarSenales($event)"></app-invmaebarra>
    </div>
</div>
<p-tabView [(activeIndex)]="index" (onChange)="changeTabs($event)" [style]="{'width':'98%'}">
    <p-tabPanel header="General">
        <p-scrollPanel [style]="{'width':'100%', 'height':'calc(100vh - 270px)'}">
            <div class="contorno" id="contorno">
                <div class="divgrups">
                    <div class="p-grid">
                        <!--LINEA 1-->
                        <div class="p-col-1">
                            <span>Archivo:</span>
                        </div>
                        <div class="p-col-5">
                            {{archivoNombre}}
                        </div>
                        <div class="p-col-1">
                            <span>Total:</span>
                        </div>
                        <div class="p-col-5">
                            <span>
                                {{
                            venimpclientesService.impclientes.length    
                            }}
                            </span>
                        </div>
                        <!--LINEA 2-->
                        <div class="p-col-12" style="margin-top: -10px">
                            <div class="p-grid">
                                <div class="p-col-1">
                                    <span>Correctos:</span>
                                </div>
                                <div class="p-col-2">
                                    <span> {{totalCorrectos}}
                                    </span>
                                </div>

                                <div class="p-col-1">
                                    <span>Errores:</span>
                                </div>
                                <div class="p-col-2">
                                    <span>{{totalErrores}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <app-aggridsaci [width]="" [height]="80" [enableSorting]="false" [enableFilter]="true"
                [rowData]="venimpclientesService.impclientes" [frameworkComponents]="frameworkComponents"
                [animateRows]="true" [rowSelection]="rowSelection" [columnDefs]="columnDefsImpCli"
                [defaultColDef]="defaultImpcliente" [rowStyle]="rowStyle" [singleClickEdit]="false" [botones]="true"
                [mostrarGuardar]="false" [botonesAdicionales]="false" [comboOpciones]="" [solobotoneliminar]="true"
                [btnsubirxls]="false" (selected)="seleccionItem($event)" [tipodetalle]="" [botonBorrar]="true"
                (cambios)="cambio($event)" [tipodetalle]="''" [botonBorrar]="true" [CC]="true">
            </app-aggridsaci>
            <div class="divgrups" style="margin-top: 10px;">
                <div class="p-grid" style="margin-bottom: -10px;">
                    <div class="p-col-4">
                        <span>Clientes ya registrados en el sistema</span>
                    </div>
                    <div class="p-col-1" style="margin-top: 10px; height: 25%; background-color: rgb(245,236,166)">
                    </div>
                    <!-- <div class="p-col-3">
                        <span for="total" class="obligatorio">Registros Procesados:</span>
                    </div>
                    <div class="p-col-1" style="margin-top:10px;height: 25%;background-color:rgb(200,230,201)">

                    </div> -->
                </div>
            </div>
        </p-scrollPanel>
    </p-tabPanel>
</p-tabView>
<input #inputFile type="file" style="display: none; opacity: 0.0; position: absolute; 
			top: 0; left: 0; bottom: 0; right: 0; width: 25px; height: 25px; cursor: pointer;" accept=".xls, .xlsx"
    (change)="onBasicUpload($event)" />
<div style=" 	position: fixed;
				z-index: 999;
				height: 2em;
				width: 2em;
				overflow: visible;
				margin: auto;
				top: 0;
				left: 0;
				bottom: 0;
				right: 0;

				">
    <p-progressSpinner *ngIf="spin" [style]="{width: '100px', height: '100px'}" animationDuration=".5s">
    </p-progressSpinner>
    <p-dialog [(visible)]="spin" [transitionOptions]="'0ms'" [modal]="true" [closable]="false"
        [style]="{ opacity: 0.00}" position="top">
    </p-dialog>
</div>
<div *ngIf="spin" class="loading">
    <span>
        Procesando
    </span>
</div>